<template>
    <div class="carefullyChosen">
        <van-list
            v-model="loading"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
            >
            <div class="banner">
                <img src="@/assets/img/carefullyChosen/buyBanner.png" alt="">
            </div> 
            <div class="navList">
                <div class="navList1">
                    <div class="nav-item" v-for="item in navList1" :key='item.name'>
                        <img :src="item.img" alt="">
                        <span>{{item.name}}</span>
                    </div>
                </div>
            <div class="navList1">
                    <div class="nav-item" v-for="item in navList2" :key='item.name'>
                        <img :src="item.img" alt="">
                        <span>{{item.name}}</span>
                    </div>
            </div>
                
            </div>
            <div class="carfully-goods">
                <div class="carfully-title">
                    <img src="@/assets/img/carefullyChosen/jingxuan.png" alt="">
                    <span>精品推荐</span>
                </div>
                <div class="good-list">
                    <good  v-for="item in goodsList" :key="item.id" :goodItem='item' />
                </div>
            </div>
        </van-list>
        
    </div>
</template>
<script>
import good from '@components/goods/good'

export default {
    components:{
        good
    },
    mounted(){
       
    },
    data(){
        return{
            navList1:[
                {name:'干果',img:require('@/assets/img/carefullyChosen/ganguo.png')},
                {name:'海鲜',img:require('@/assets/img/carefullyChosen/haixian.png')},
                {name:'牛排',img:require('@/assets/img/carefullyChosen/niupai.png')},
                {name:'熟食',img:require('@/assets/img/carefullyChosen/shushiqu.png')},
               
            ],
            navList2:[
                {name:'茶叶',img:require('@/assets/img/carefullyChosen/chaye.png')},
                {name:'酒水',img:require('@/assets/img/carefullyChosen/jiushui.png')},
                {name:'甜点',img:require('@/assets/img/carefullyChosen/gaodian.png')},
                {name:'零食',img:require('@/assets/img/carefullyChosen/lingshi.png')},
            ],
            goodsList:[
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:1,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:2,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:3,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:4,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:5,img:require('@/assets/img/carefullyChosen/goods.png')},
            ],
             error: false,
            loading: false,
        }
    },
    methods:{
         onLoad() {
             console.log('到达底部')
        },
    }
}
</script>
<style lang="scss" scoped>
    .carefullyChosen{
        width: 100%;
        background: #F9F9F9;
        .banner{
            width: 100%;
            height: 397px;
            z-index: -1;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .navList{
            width:702px;
            padding: 28px 53px;
            padding-top: 2px;
            box-sizing: border-box;
            background:rgba(251,251,251,1);
            box-shadow:0px 4px 11px 0px rgba(4,0,0,0.14);
            border-radius:10px;
            margin: 0 auto;
            position: relative;
            top: -140px;
            .navList1{
                display: flex;
                justify-content: space-between;
                margin-top: 26px;
                .nav-item{
                    width: 94px;
                    text-align: center;
                    img{
                        width: 94px;
                        height: 94px;
                    }
                }
            }
        }
         .carfully-goods{
                width: 100%;
                box-sizing: border-box;
                padding: 0 24px;
                position: relative;
                top: -100px;
                .carfully-title{
                    display: flex;
                    align-items: center;
                    img{
                        width: 30px;
                        height: 30px;
                        margin-right: 15px;
                    }
                    span{
                        font-size:32px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(68,68,68,1);
                    }
                }
                .good-list{
                   padding: 33px 0;
                   display: flex;
                   flex-wrap: wrap;
                   justify-content: space-between;
                    
                }
            }
    }    
</style>